/** @type {import('./calendarStore').CalendarStore | null} */
let activeCalendarStore = null;

export function registerCalendarStore(store) {
   activeCalendarStore = store || null;
}

export function getCalendarStore() {
   return activeCalendarStore;
}

/** @internal */
export function __resetCalendarStoreRegistryForTests() {
   activeCalendarStore = null;
}
